import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import GuestLayout from '../layouts/GuestLayout';

const PublicRouteRedirect = ({ isAuthenticated, i18n }) => {
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <GuestLayout i18n={i18n} />;
};

export default PublicRouteRedirect;
